module.exports = __webpack_public_path__ + "img/wide.b6d53339.jpg";